import { fromJoules, toJoules } from "../shared/energy-and-emission-conversion";
import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP } from "../ghg-administration";
const DATA_SOURCE_MAX_LENGTH = 1000;
const municipalFacilities = GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.sectors.MUNICIPAL_FACILITIES;
const waterConsumption = GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.sectors.WATER_CONSUMPTION;
const APPROVED_BUILDING_ENERGY_SOURCE_KEY_LIST = [
    "NATURAL_GAS",
    "HEATING_OIL",
    "LIQUID_GAS",
    "BIOGAS",
    "BIOMASS",
    "LIGNITE",
    "HARD_COAL",
    "SOLAR_THERMAL",
    "AMBIENT_HEAT",
    "OTHER_CONVENTIONAL",
    "OTHER_RENEWABLE",
    "ELECTRICITY",
    "HEATING_ELECTRICITY",
    "DISTRICT_HEATING",
    "LOCAL_HEATING",
];
const buildingEnergyCellList = APPROVED_BUILDING_ENERGY_SOURCE_KEY_LIST.map((energySourceKey) => {
    const energySource = municipalFacilities.energySources[energySourceKey];
    return {
        sectorKey: "MUNICIPAL_FACILITIES",
        subsectorKey: null,
        energySourceKey,
        scope: energySource.scope,
        inputUnit: "MWh",
        storageUnit: "J",
    };
});
const waterCell = {
    sectorKey: "WATER_CONSUMPTION",
    subsectorKey: "WATER_CONSUMPTION",
    energySourceKey: "WATER",
    scope: waterConsumption.energySources.WATER.scope,
    inputUnit: waterConsumption.unit,
    storageUnit: waterConsumption.unit,
};
const cellList = [...buildingEnergyCellList, waterCell];
function isSameCoordinate(left, right) {
    return (left.sectorKey === right.sectorKey &&
        left.subsectorKey === right.subsectorKey &&
        left.energySourceKey === right.energySourceKey);
}
export const MUNICIPAL_PROPERTY_VALUE_CELL_POLICY = {
    cellList,
    dataSourceMaxLength: DATA_SOURCE_MAX_LENGTH,
    findCell: (coordinate) => cellList.find((cell) => isSameCoordinate(cell, coordinate)),
    findCellByEnergySource: (energySourceKey) => cellList.find((cell) => cell.energySourceKey === energySourceKey),
    isApproved: (coordinate) => cellList.some((cell) => isSameCoordinate(cell, coordinate)),
    toInputAmount: (cell, amount) => cell.storageUnit === "J" ? fromJoules(amount, "MWh") : amount,
    toStorageAmount: (cell, amount) => cell.storageUnit === "J" ? toJoules(amount, "MWh") : amount,
};
